"use strict";

import $ from 'jquery';
import * as ad from "./ad";
import {isSmallDevice} from './isSmallDevice.js';

export function initialize() {
  function insertInArticle() {
    const $articleArea = $('[data-inarticle-type="dynamic"]');
    const excludeArea = ".article-block-link, .article-block-profile, .article-block-tag, .article-block-share, .article-block-magazine";
    const $articlePart = $articleArea.find('.article-body').children(`[class^="article-block-"]:not(${excludeArea})`);
    const baseline = (window.innerHeight * 1.5) || 750;

    let articlePartSet = {};
    let basePos = 0;
    let adNumber = 1;

    $articlePart.each(function () {
      let partPosTop = $(this).position().top;
      articlePartSet[partPosTop] = $(this);
    });

    $.each(articlePartSet, function (partPos, self) {
      if (adNumber <= 2) {
        if ((partPos - basePos) >= baseline) {
          $(self).before(createPlaceholder(adNumber));
          adNumber++;
          basePos = partPos;
        }
      }
    });
  }

  if (isSmallDevice()) {
    insertInArticle();
    ad.addNewAd();
  }
}

function createPlaceholder(num) {
  let lazyload = '';
  if (num > 1) {
    lazyload = " data-ad-lazyload='true'";
  }
  return '<div class="SP_inarticle"><div class="SP_inarticle_text"><span>Ã¨Â¨ÂÃ¤ÂºÂÃ£ÂÂÃ§Â¶ÂÃ£ÂÂÃ£ÂÂ¾Ã£ÂÂ</span></div><div id="SP_inarticle_' + num + '_dynamic" data-ad-unit-name="maquia_SP_inarticle_' + num + '_DFP_3rd"' + lazyload + '></div>';
}
